// Attuned homepage (sections/ah-home.liquid). The hero's fluted glass straightens as you scroll, a scan line marks
// the six systems, the statement fills in, How it works pins its frame, and the Endurance band checks off its systems.
(() => {
  // every band section loads this file; run it once
  if (window.ahHomeJs) return; window.ahHomeJs = 1;
  const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x)), ease = t => 1 - Math.pow(1 - t, 3), lerp = (a, b, t) => a + (b - a) * t;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const phone = () => innerWidth <= 720;
  // where the scan line marks each system, as fractions of the screen
  const MARKS = [[.22, .52], [.38, .31], [.52, .50], [.62, .19], [.79, .42], [.90, .25]];
  const MARKS_M = [[.08, .16], [.52, .13], [.30, .24], [.62, .29], [.10, .34], [.58, .40]];

  function init(root) {
    if (root.dataset.ahReady) return; root.dataset.ahReady = '1';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    let vh = innerHeight;
    const setVh = () => { vh = innerHeight; root.style.setProperty('--vh', vh + 'px'); };
    setVh();

    // add to cart on the product cards, then open the theme's cart drawer
    $$('[data-add]').forEach(btn => btn.addEventListener('click', async () => {
      const err = btn.parentElement.querySelector('[data-err]');
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true'); if (err) err.hidden = true;
      try {
        const r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.add, quantity: 1 }] }) });
        const d = await r.json();
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart. Please try again.');
        if (typeof updateCartCounts === 'function') updateCartCounts();
        if (typeof loadEgCartDrawer === 'function') loadEgCartDrawer(); else location.href = '/cart';
      } catch (x) { if (err) { err.textContent = x.message; err.hidden = false; } }
      finally { btn.removeAttribute('aria-disabled'); }
    }));

    // hero: headline words rise in on load
    const hero = $('[data-hero]'), stage = hero && hero.querySelector('.stage');
    const l1 = $('[data-l1]');
    if (l1) {
      l1.textContent = '';
      let n = 0;
      [l1.dataset.l1, l1.dataset.l1b].forEach(line => {
        (line || '').split(' ').filter(Boolean).forEach(w => {
          const o = document.createElement('span'), s = document.createElement('span');
          o.className = 'w'; s.textContent = w; s.style.transitionDelay = (0.15 + n++ * 0.08) + 's';
          o.append(s); l1.append(o, ' ');
        });
        l1.append(document.createElement('br'));
      });
      requestAnimationFrame(() => setTimeout(() => hero.classList.add('ready'), 60));
    }

    // the fluted glass: one strip per rib, each showing its slice of the photo, pushed sideways while k > 0
    const ribsEl = $('[data-ribs]'), scan = $('[data-scan]'), mksEl = $('[data-mks]');
    let ribs = [], N = 0, geo = null;
    function buildRibs() {
      if (!stage) return;
      const m = phone() && root.dataset.heroM, src = m ? root.dataset.heroM : root.dataset.heroD;
      const iw = +(m ? root.dataset.heroMw : root.dataset.heroDw), ih = +(m ? root.dataset.heroMh : root.dataset.heroDh);
      const W = stage.clientWidth, H = stage.clientHeight, s = Math.max(W / iw, H / ih) * 1.04, bw = iw * s, bh = ih * s;
      geo = { W, H, bw, bh, ox: (W - bw) / 2, oy: (H - bh) / 2 };
      N = phone() ? 9 : 22; ribsEl.textContent = ''; ribs = [];
      const w = W / N;
      for (let i = 0; i < N; i++) {
        const d = document.createElement('div'); d.className = 'rib';
        d.style.cssText = `left:${(i * w).toFixed(2)}px;width:${(w + 1).toFixed(2)}px;${src ? `background-image:url(${src});` : ''}background-size:${bw}px ${bh}px`;
        ribsEl.append(d); ribs.push({ d, x: i * w, sh: Math.sin(i * 1.7 + 0.6) * 0.9 + (i % 2 ? .35 : -.35) });
      }
      mksEl.textContent = '';
      const names = (phone() ? root.dataset.marksM : root.dataset.marks).split('|');
      (phone() ? MARKS_M : MARKS).forEach(([fx, fy], i) => {
        if (!names[i]) return;
        const x = fx * W, y = fy * H, mk = document.createElement('div');
        mk.className = 'mk'; mk.style.left = x + 'px'; mk.style.top = y + 'px'; mk.dataset.x = x;
        if (x > W * .78) { mk.classList.add('flip'); mk.style.left = (x + 9) + 'px'; }
        mk.innerHTML = '<i></i><span></span>'; mk.querySelector('span').textContent = names[i]; mksEl.append(mk);
      });
    }
    function drawHero(p) {
      if (!geo) return;
      // 0 to .42: the glass straightens and the blur clears; .38: line two; .45 to .8: the scan line crosses
      const k = 1 - ease(clamp(p / .42)), w = geo.W / N;
      ribsEl.style.filter = `blur(${(k * 10).toFixed(2)}px) brightness(${(0.82 + 0.18 * (1 - k)).toFixed(3)})`;
      ribsEl.style.transform = `scale(${(1 + 0.08 * k).toFixed(4)})`;
      ribsEl.style.setProperty('--k', k.toFixed(3));
      for (const r of ribs) r.d.style.backgroundPosition = `${(geo.ox - r.x + r.sh * w * 1.6 * k).toFixed(1)}px ${(geo.oy + r.sh * 18 * k).toFixed(1)}px`;
      const l2 = $('[data-l2]'); if (l2) l2.classList.toggle('on', p > .38);
      const s = clamp((p - .45) / .35), sx = lerp(-20, geo.W + 20, s);
      scan.style.opacity = s > 0 && s < 1 ? 1 : 0; scan.style.transform = `translateX(${sx}px)`;
      mksEl.querySelectorAll('.mk').forEach(m => m.classList.toggle('on', s > 0 && sx > +m.dataset.x));
      const cue = $('[data-cue]'); if (cue) cue.style.opacity = p > .05 ? 0 : 1;
    }

    // statement: words fill as the paragraph passes through the screen
    const say = $('[data-say]'); let words = [];
    if (say) { say.innerHTML = say.textContent.trim().split(/\s+/).map(w => `<span class="x">${w.replace(/</g, '&lt;')}</span>`).join(' '); words = [...say.querySelectorAll('.x')]; }

    // how it works: the frame pins, the steps change around it
    const how = $('[data-how]'), hl = $$('[data-hl]>div'), hr = $$('[data-hr]>p'), hm = $$('[data-hf] .m'), bars = $$('[data-bars] b'), ang = $('[data-ang]');
    let step = -1;
    function drawHow(p) {
      const n = Math.min(hm.length - 1, Math.floor(p * hm.length)), within = clamp(p * hm.length - n);
      bars.forEach((b, i) => b.style.transform = `scaleX(${i < n ? 1 : i === n ? within : 0})`);
      if (n === step) return; step = n;
      [hl, hr].forEach(a => a.forEach((e, i) => e.classList.toggle('off', i !== n)));
      hm.forEach((e, i) => { e.classList.toggle('on', i === n); const v = e.querySelector('video'); if (v) { if (i === n) { v.currentTime = 0; v.play().catch(() => {}); } else v.pause(); } });
      if (ang) ang.style.visibility = hm[n] && hm[n].querySelector('video') ? 'visible' : 'hidden';
    }
    hm.forEach(e => { const v = e.querySelector('video'); if (v && ang) v.addEventListener('timeupdate', () => { if (v.duration) ang.textContent = String(Math.round(v.currentTime / v.duration * 360) % 360).padStart(3, '0') + '°'; }); });

    // Endurance: the block caps run with the scroll; the scan line checks off each system by the time the band is in view
    const end = $('[data-end]'), runa = $('[data-runa]'), runb = $('[data-runb]'), endimg = end && end.querySelector('.endimg'), escan = $('[data-escan]'), sysli = $$('[data-sys] li:not(.h)');
    function drawEnd(s) {
      s = clamp(s);
      if (escan) { escan.style.opacity = s > 0 && s < 1 ? 1 : 0; escan.style.transform = `translateX(${(s * end.clientWidth).toFixed(1)}px)`; }
      sysli.forEach((li, i) => li.classList.toggle('on', s >= (i + 1) / sysli.length - .02));
    }

    function frame() {
      if (hero) { const r = hero.getBoundingClientRect(); drawHero(clamp(-r.top / (hero.offsetHeight - stage.offsetHeight))); }
      if (say) { const r = say.getBoundingClientRect(), sp = clamp((vh * .82 - r.top) / (r.height + vh * .3)); words.forEach((w, i) => w.classList.toggle('on', i / words.length < sp)); }
      if (how) { const r = how.getBoundingClientRect(); drawHow(clamp(-r.top / (how.offsetHeight - vh))); }
      if (end) {
        const r = end.getBoundingClientRect(), ep = (vh - r.top) / (vh + r.height);
        if (runa) runa.style.transform = `translateX(${(-ep * 40).toFixed(2)}%)`;
        if (runb) runb.style.transform = `translateX(${(-30 + ep * 30).toFixed(2)}%)`;
        if (endimg) endimg.style.transform = `translateY(${((ep - .5) * -8).toFixed(2)}%)`;
        const top0 = vh * .7, top1 = Math.min(vh - r.height, vh * .25);
        drawEnd((top0 - r.top) / (top0 - top1));
      }
    }
    let ticking = false;
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; frame(); }); } };

    // phone: the product cards swipe, the dots follow
    const cards = $('[data-cards]'), dots = $('[data-dots]');
    if (cards && dots) cards.addEventListener('scroll', () => { const f = cards.firstElementChild; if (!f) return; const i = Math.round(cards.scrollLeft / (f.offsetWidth + 12)); dots.querySelectorAll('i').forEach((d, j) => d.classList.toggle('on', j === i)); }, { passive: true });

    // the note: one strip per handwritten line, shown whole (Josh, Oct 28: no writing-in animation on the founder note)
    const ink = $('[data-ink]');
    if (ink) (root.dataset.bands || '').split(',').map(x => x.split('-').map(Number)).filter(b => b.length === 2 && b[1] > b[0]).forEach(([a, b], i) => {
      const s = Math.max(0, a - .008), e = Math.min(1, b + .008), d = document.createElement('i');
      d.style.cssText = `top:${(s * 100).toFixed(3)}%;height:${((e - s) * 100).toFixed(3)}%;background-position:0 ${(s / (1 - (e - s)) * 100).toFixed(3)}%;clip-path:none;transition:none`;
      ink.append(d);
    });

    function setup() { if (dots) dots.hidden = !phone(); buildRibs(); frame(); }
    setup();
    const settle = () => { $$('.rv,.co li,[data-ink],[data-thread] .msg').forEach(e => e.classList.add('in')); words.forEach(w => w.classList.add('on')); drawHero(.62); };
    if (reduce) { settle(); return; }

    // one-shot reveals, the message thread, and videos that play only while on screen; the product cards come in together
    // (on phone they sit in a swipe row, so the second card would otherwise wait until it was swiped to)
    const io = new IntersectionObserver(es => es.forEach(e => { if (!e.isIntersecting) return; const grp = e.target.closest('[data-cards]'); (grp ? [...grp.querySelectorAll('.rv')] : [e.target]).forEach(t => { t.classList.add('in'); io.unobserve(t); }); }), { threshold: .18 });
    $$('.rv,.co li,[data-ink]').forEach(e => io.observe(e));
    const thread = $('[data-thread]');
    if (thread) {
      const msgs = [...thread.querySelectorAll('.msg')], typing = thread.querySelector('[data-typing]');
      const tio = new IntersectionObserver(es => { if (!es[0].isIntersecting) return; tio.disconnect();
        msgs.forEach((m, i) => { setTimeout(() => typing && typing.classList.add('on'), i * 1500); setTimeout(() => { typing && typing.classList.remove('on'); m.classList.add('in'); }, i * 1500 + 900); });
      }, { threshold: .35 });
      tio.observe(thread);
    }
    const vio = new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause()), { threshold: .3 });
    $$('video[data-autoplay]').forEach(v => vio.observe(v));

    addEventListener('scroll', onScroll, { passive: true });
    let rw = innerWidth;
    addEventListener('resize', () => { if (innerWidth !== rw) { rw = innerWidth; setVh(); setup(); } else onScroll(); });
  }

  const run = () => document.querySelectorAll('[data-ah]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // the theme editor re-renders the section when a setting changes
  document.addEventListener('shopify:section:load', e => { const r = e.target.querySelector('[data-ah]'); if (r) init(r); });
})();
// Move 2 (the rotating pill) lives in assets/move2.js; bump m2= whenever that file changes, since the CDN caches by full URL
(function () { if (window.ahM2) return; window.ahM2 = 1; var me = document.currentScript && document.currentScript.src; if (!me) return; var s = document.createElement('script'); s.src = me.replace(/(ah-home)\.js/, 'move2.js') + (me.indexOf('?') < 0 ? '?' : '&') + 'm2=7'; s.defer = true; document.head.appendChild(s); })();
